import { useState, useEffect, useCallback } from 'react'
import useAuthenStore from '../../stores/authen/authenStore'

import useCallApi from '../../utilities/axios'

export type Keyword = {
    userID: number
}

export type SettingRECListType = {
    id: number
    name: Translation
    rec: {
        id: number
        name: Translation
    }
}

export type PostSettingRECType = {
    userID: number
    nameTH: string | null
    nameEN: string | null
    recID: string | null
    addressTH: string | null
    addressEN: string | null
    telephone: string | null
    email: string | null
    headerCertificateEN: string | null
    headerCertificateTH: string | null
    headerMemorandumEN: string | null
    headerMemorandumTH: string | null
    organizationEN: string | null
    organizationTH: string | null
}

type Translation = {
    th: string
    en: string
}

export type Order = 'desc' | 'asc'

export type FormType = {
    nameTH: string | null
    nameEN: string | null
    recID: string | null
    addressTH: string | null
    addressEN: string | null
    telephone: string | null
    email: string | null

    headerCertificateEN: string | null
    headerCertificateTH: string | null
    headerMemorandumEN: string | null
    headerMemorandumTH: string | null
    organizationEN: string | null
    organizationTH: string | null
}

export const useSettingREC = (id?: number) => {
    const [settingREC, setSettingREC] = useState<FormType>()

    const callApi = useCallApi()

    useEffect(() => {
        id && getSettingRECByID(id)
    }, [])

    const getSettingREC = useCallback(async (values: Keyword) => {
        const { data } = await callApi.axiosGet({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/rec/search?userID=${values.userID}`,
        })

        return data
    }, [])

    const potSettingREC = async (values: PostSettingRECType) => {
        const { data } = await callApi.axiosPost({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/rec`,
            params: values,
        })

        return data
    }

    const getSettingRECByID = async (id: number) => {
        const { data } = await callApi.axiosGet({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/rec/${id}`,
        })
        setSettingREC(data)
        return data
    }

    const putSettingREC = async (id: number, values: PostSettingRECType) => {
        const { data } = await callApi.axiosPut({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/rec/${id}`,
            params: values,
        })

        return data
    }

    const getMasterRECByID = async (recID: number) => {
        //ดึงข้อมูลของ REC หลัง 1 หรอ 2
        const { data } = await callApi.axiosGet({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/masterREC/${recID}`,
        })

        return data
    }

    return {
        getSettingREC,
        potSettingREC,
        getSettingRECByID,
        settingREC,
        putSettingREC,
        getMasterRECByID,
    }
}
